import { useState, useMemo, useEffect } from 'react';
import { Item } from '../../mechanics/items/Item';
import { uiSlice } from '../../store/reducers/uiReducer';
import { userSlice } from '../../store/reducers/userReducer';
import { useAppDispatch, useAppSelector } from '../../store/store';
import ImgWithFallback from '../ui/ImgWithFallback';
import ToolTip, { IToolTipObject } from '../ui/ToolTip';
import UseItemOptions from '../ui/UseItemOptions';

interface IInventoryItemProps {
    item: Item
    index: number
    setPlayerHp?: React.Dispatch<React.SetStateAction<number>>
}

const InventoryItem = ({ item, index, setPlayerHp }: IInventoryItemProps) => {
    // redux const
    const mainCharacter = useAppSelector(state => state.userReducer.character)
    const characterInventory = useAppSelector(state => state.userReducer.character.getInventory())
    const dispatch = useAppDispatch()
    const { setInventoryLength, setIsEquipmentChange, setIsBuyOrSellItem } = userSlice.actions
    const { setToolTipContent, setIsUseItemOptionsView } = uiSlice.actions
    const toolTipContent = useAppSelector(state => state.uiReducer.toolTipContent)
    const isUseItemOptionsView = useAppSelector(state => state.uiReducer.isUseItemOptionsView)
    // state const
    const [itemCount, setItemCount] = useState(item.getCount())
    const [isToolTipView, setIsToolTipView] = useState(false)

    // ! do not delete const in next three line. Alert костЫль!!!)))))
    const isArmorEquipped = mainCharacter.getEquipment().armor.getArmorType()
    const isWeaponEquipped = mainCharacter.getEquipment().weapon.getWeaponType()
    const isEquipmentChange = useAppSelector(state => state.userReducer.isEquipmentChange)
    const isBuyOrSellItem = useAppSelector(state => state.userReducer.isBuyOrSellItem)

    useEffect(() => {
        setItemCount(item.getCount())
    }, [isBuyOrSellItem])

    function callToolTip(tipContent: string) {
        setIsToolTipView(true)
        dispatch(setToolTipContent(tipContent))
    }

    const [viewItemOptions, setViewItemOptions] = useState(false)

    const classViewOptions = viewItemOptions && itemCount ? '_view-options' : ''

    const handleClick = () => {
        setViewItemOptions(!viewItemOptions)
    }

    const toolTipObjectContent: IToolTipObject = {
        type: item.getType(),
        name: item.getName(),
        restoreValue: item.getRestoreValue(),
        armorValue: item.getArmorValue(),
        weaponDamage: item.getWeaponDamage(),
        cost: item.getCost()
    }

    return (
        <li
            className={`inventory__body-item ${classViewOptions}`}
            onClick={handleClick}
            onMouseEnter={() => callToolTip(toolTipContent)}
            onMouseLeave={() => setIsToolTipView(false)}
        >
            {itemCount ? <ImgWithFallback src={item.getImg().webp} fallbackSrc={item.getImg().img} /> : null}
            {itemCount ? <span>{itemCount}</span> : null}
            {isToolTipView && item.getType() ?
                <ToolTip
                    text=''
                    toolTipObjectContent={toolTipObjectContent}
                    position='top-inventory-items' />
                :
                null
            }
            {viewItemOptions && itemCount ?
                <UseItemOptions
                    item={item}
                    itemCount={itemCount}
                    setItemCount={setItemCount}
                    index={index}
                    setPlayerHp={setPlayerHp}
                    setViewItemOptions={setViewItemOptions} />
                :
                null
            }
        </li>
    );
};

export default InventoryItem;